import type { FilterCharacter, FilterFandom, FilterTag } from '@/types/filter-data';
import type { FilterItem } from '../types/fanfiction-filters.types';

export const mapFandomToFilterItem = (fandom: FilterFandom, isChecked: boolean): FilterItem => ({
  id: fandom.id,
  name: fandom.name,
  count: fandom.count,
  permanentUrl: fandom.permanentUrl,
  checked: isChecked,
});

export const mapCharacterToFilterItem = (
  character: FilterCharacter,
  isChecked: boolean,
): FilterItem => ({
  id: character.id,
  name: character.name,
  count: character.count,
  fandomTitle: character.fandomTitle,
  permanentUrl: character.permanentUrl,
  fandomId: character.fandomId,
  checked: isChecked,
});

export const mapTagToFilterItem = (tag: FilterTag, isChecked: boolean): FilterItem => ({
  id: tag.id,
  name: tag.name,
  count: tag.count,
  permanentUrl: tag.permanentUrl,
  checked: isChecked,
});
